<script setup>
import Vue, {computed, reactive, ref} from "vue";
import useForm from "@/composables/useForm";
import inviteService from "@/services/invite.service";
import PrimaryButton from "@/components/ui/PrimaryButton.vue";
import EmailTemplateEdit from "@/components/settings/EmailTemplateEdit.vue";
import companyService from "@/services/company.service";
import {validEmail} from "@/helpers/string";

const {trackerId} = defineProps({
    trackerId: {
        type: Number,
        default: 0,
    }
});
const emit = defineEmits(['invited']);
const showModal = ref(false);

const startupId = ref(0);
const loading = ref(false);
const emailTemplateEditModal = ref(null);

const form = reactive({
    contactEmail: "",
    trackerId: trackerId,
    emailTemplate: {
        subject: "",
        body: "",
    },
})

const {resetForm, errors, setErrors, hasErrors, clearErrors} = useForm(form);

const validContactEmail = computed(() => validEmail(form.contactEmail));

async function send() {
    loading.value = true;
    clearErrors();
    const {data} = await inviteService.inviteStartup(startupId.value, form);

    setErrors(data.errors);
    loading.value = false;

    if (!hasErrors(data)) {
        showModal.value = false;

        if (data.failure) {
            Vue.notify({
                group: 'app',
                type: 'error',
                duration: 5000,
                text: data.result
            })
        } else {
            emit('invited');

            Vue.notify({
                group: 'app',
                type: 'success',
                duration: 5000,
                text: data.result
            })
        }
    }
}

async function editTemplate() {
    if (!form.emailTemplate.subject.length) {
        const {data} = await companyService.getEmailTemplateEdit('startup-invite');

        form.emailTemplate.subject = data.subject
        form.emailTemplate.body = data.body
    }

    showModal.value = false;
    emailTemplateEditModal.value.open(form.emailTemplate);
}

function setTemplate(template) {
    form.emailTemplate = template;
}

function open(id) {
    startupId.value = id;
    showModal.value = true;
    resetForm();
}

defineExpose({
    open
});
</script>

<template>
    <div>
        <b-modal v-model="showModal" title="Invite Startup">
            <div class="form mt-3">
                <h5 class="heading5 heading5--secondary">Contact Email*</h5>

                <span v-if="errors.contactEmail.length" class="form__error">
                    {{errors.contactEmail[0]}}
                </span>

                <b-form-input class="form-control--mid mb-2" v-model="form.contactEmail"></b-form-input>
            </div>

            <template #modal-footer>
                <div class="buttons-wrapper">
                    <button
                        v-if="validContactEmail"
                        class="btn btn-bordered btn-lg"
                        @click="editTemplate"
                    >
                        Customize Invite
                    </button>

                    <PrimaryButton
                        caption="Invite"
                        loading-caption="Sending..."
                        :loading="loading"
                        :disabled="!form.contactEmail.length"
                        @click="send"
                    />
                </div>
            </template>
        </b-modal>

        <EmailTemplateEdit
            ref="emailTemplateEditModal"
            @saved="setTemplate"
            @closed="showModal = true"
        />
    </div>
</template>

<style scoped>

</style>
